/**
 * Optimized Buy It Now (Unbranded)
 * - Adds item via Cart API
 * - Redirects to checkout
 * - Lightweight + performant
 */
(function () {
  function getForm(button) {
    const formId = button.dataset.productForm;
    return formId ? document.getElementById(formId) : null;
  }

  /** Stable string id for [form="…"] selectors (form.id can be non-string in some DOM edge cases). */
  function getFormElementId(form) {
    if (!form || typeof form.getAttribute !== 'function') return '';
    const fromAttr = form.getAttribute('id');
    if (fromAttr != null && String(fromAttr).length) return String(fromAttr);
    const legacy = form.id;
    if (legacy != null && String(legacy).length) return String(legacy);
    return '';
  }

  function escapeForFormSelector(idStr) {
    return String(idStr).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  /**
   * Theme quantity (and other) inputs often sit outside the <form> but use form="productform-…".
   * form.querySelector misses those; form.elements and [form=id] do not.
   */
  function getFormField(form, name) {
    let el = form.elements.namedItem(name);
    if (el && typeof el.length === 'number' && !el.tagName) {
      el = el.length === 1 ? el[0] : Array.from(el).find((node) => node.checked) || el[0];
    }
    if (!el) {
      const fid = getFormElementId(form);
      if (fid) {
        const escaped = escapeForFormSelector(fid);
        el = document.querySelector(
          `input[name="${name}"][form="${escaped}"], select[name="${name}"][form="${escaped}"], textarea[name="${name}"][form="${escaped}"]`,
        );
      }
    }
    if (!el) {
      el = form.querySelector(`[name="${name}"]`);
    }
    return el;
  }

  function parseQuantity(form) {
    const el = getFormField(form, 'quantity');
    const raw = el && 'value' in el ? String(el.value).trim() : '1';
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n >= 1 ? n : 1;
  }

  function getLineItem(form) {
    const idInput = getFormField(form, 'id') || form.querySelector('[name="id"]');
    const id = parseInt(idInput?.value, 10);
    if (!id) return null;

    const quantity = parseQuantity(form);

    const item = { id, quantity };

    const sellingPlan = getFormField(form, 'selling_plan')?.value;
    if (sellingPlan) item.selling_plan = Number(sellingPlan);

    const props = {};
    form.querySelectorAll('[name^="properties["]').forEach((el) => {
      if (el.type === 'checkbox' && !el.checked) return;
      const key = el.name.match(/\[(.*?)\]/)?.[1];
      const val = el.value?.trim();
      if (key && val) props[key] = val;
    });
    const fid = getFormElementId(form);
    if (fid) {
      const escaped = escapeForFormSelector(fid);
      document.querySelectorAll(`[name^="properties["][form="${escaped}"]`).forEach((el) => {
        if (el.type === 'checkbox' && !el.checked) return;
        const key = el.name.match(/\[(.*?)\]/)?.[1];
        const val = el.value?.trim();
        if (key && val) props[key] = val;
      });
    }

    if (Object.keys(props).length) item.properties = props;

    return item;
  }

  function checkoutUrl() {
    const cartUrl = window.routes?.cart_fetch_url || '/cart';
    return String(cartUrl).replace(/\/?cart\/?$/i, '/checkout');
  }

  async function handleClick(button) {
    if (button.classList.contains('is-loading')) return;

    const form = getForm(button);
    if (!form) return;

    const item = getLineItem(form);
    if (!item) {
      alert('Please select a variant');
      return;
    }

    button.classList.add('is-loading');
    button.disabled = true;

    const spinner = button.querySelector('[data-buy-now-spinner]');
    spinner?.classList.remove('d-none');

    const addUrl = `${window.routes?.cart_add_url || '/cart/add'}.js`;

    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: [item] }),
        credentials: 'same-origin',
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const msg =
          data.description ||
          data.message ||
          (data.errors &&
            (typeof data.errors === 'string' ? data.errors : JSON.stringify(data.errors))) ||
          'Could not add to cart. Please try again.';
        alert(msg);
        button.classList.remove('is-loading');
        button.disabled = false;
        spinner?.classList.add('d-none');
        return;
      }

      window.location.assign(checkoutUrl());
    } catch (err) {
      console.error('Buy Now Error:', err);
      alert('Something went wrong. Please try again.');

      button.classList.remove('is-loading');
      button.disabled = false;
      spinner?.classList.add('d-none');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-product-buy-now]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    handleClick(btn);
  });
})();